module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-button', {
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px",
      "margin-bottom": "4px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.FilterCB()
      }
    }
  }, [_vm._v("Booking No Search")]), _vm._v(" "), _c('b-modal', {
    ref: "FilterCB-modal",
    attrs: {
      "id": "FilterCB-modal",
      "title": "Filter CB",
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-input', {
    staticClass: "mb-2 w-100",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    on: {
      "keyup": function($event) {
        _vm.CBFilterFunct(true)
      }
    },
    model: {
      value: (_vm.filterCBNO),
      callback: function($$v) {
        _vm.filterCBNO = $$v
      },
      expression: "filterCBNO"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    on: {
      "click": function($event) {
        _vm.CBFilterFunct(false)
      }
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.CBList.length) + " Entries")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.DataSearch))]), _vm._v(" "), (_vm.ismodalLoding) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.CBList,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "booking_no",
      fn: function(row1) {
        return [(row1.item.bookingType) ? _c('span', [_vm._v("\n              Booking Type. :" + _vm._s(row1.item.bookingType) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.contract_no) ? _c('span', [_vm._v("\n              Contract No. :" + _vm._s(row1.item.contract_no) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(row1.item.booking_no))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Created Dt. :" + _vm._s(_vm._f("moment")(row1.item.created_at)) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Release Dt. :" + _vm._s(_vm._f("moment")(row1.item.release_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n              Raised From : " + _vm._s(row1.item.raisedFrom) + "\n              "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("By : " + _vm._s(row1.item.raisedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.UpdatedBy) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("\n              Update Dt : " + _vm._s(row1.item.UpdatedDate) + "\n              "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.UpdatedBy) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("Update By : " + _vm._s(row1.item.UpdatedBy))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "ClientName",
      fn: function(row2) {
        return [(row2.item.fk_client_id == '0') ? _c('b', [_vm._v(_vm._s("NOT AVAILABLE"))]) : (row2.item.ClientName != '') ? _c('b', [_vm._v(_vm._s(row2.item.ClientName))]) : _vm._e()]
      }
    }, {
      key: "shippingLine",
      fn: function(row3) {
        return [(row3.item.shippingLine != '') ? _c('b', [_vm._v(_vm._s(row3.item.shippingLine))]) : _vm._e()]
      }
    }, {
      key: "POD",
      fn: function(row3) {
        return [_vm._v("\n            Branch :\n            "), (row3.item.Branch_Name != '') ? _c('b', [_vm._v("\n              " + _vm._s(row3.item.Branch_Name) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("POR :\n            "), (row3.item.POR != '') ? _c('b', [_vm._v(_vm._s(row3.item.POR))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("POD :\n            "), (row3.item.POD != '') ? _c('b', [_vm._v(_vm._s(row3.item.POD))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("POL :\n            "), (row3.item.POL != '') ? _c('b', [_vm._v(_vm._s(row3.item.POL))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "vessel_sale_start_date",
      fn: function(row10) {
        return [(row10.item.validity_start != '') ? _c('b', [_vm._v("Validity Date : " + _vm._s(row10.item.validity_start))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row10.item.validity_end != '') ? _c('b', [_vm._v("/" + _vm._s(row10.item.validity_end))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row10.item.vessel_sale_start_date != '') ? _c('b', [_vm._v("Vessel Sail Date : " + _vm._s(row10.item.vessel_sale_start_date))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row10.item.vessel_sale_end_date != '') ? _c('b', [_vm._v("/" + _vm._s(row10.item.vessel_sale_end_date))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "mainSeries",
      fn: function(row6) {
        return [_vm._v(_vm._s(row6.item.mainSeries))]
      }
    }, {
      key: "BookingStatus",
      fn: function(row7) {
        return [(row7.item.prbr_id) ? _c('BRFCard', {
          attrs: {
            "BRFDetails": null,
            "prbr_id": Number(row7.item.prbr_id)
          }
        }) : _vm._e(), _vm._v(" "), _c('b-badge', [_vm._v(_vm._s(row7.item.isbookingactive == 1 ? "Active" : "In-Active"))]), _c('br'), _vm._v(" "), _c('b-badge', [_vm._v(_vm._s(row7.item.BookingStatus == 1 ?
          "RELEASED" :
          row7.item.BookingStatus == 2 ?
          "UNRELEASED" :
          row7.item.BookingStatus == 3 ?
          "CANCELLED" :
          "All"))])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideFilterCB
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b3281a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/filterCBModal.vue
// module id = 2766
// module chunks = 0